import { RoleEnum } from '@acme/api';
import { useExchangeRate, useRecommendedRate, useUser } from '@acme/domains';
import {
  EExchangeTableState,
  ErrorPage,
  ExchangeRateTable,
  RecommendedExchangeRates,
} from '@acme/features';
import {
  AdminRateTable,
  EExchangeTableMode,
} from '@acme/features/widgets/exchangeRate/ui';
import { TabItem, Tabs, docsTabsTheme } from '@acme/foundation';
//вопросы к беку
// update от providera
// комменты к заблокированным курсам
// expireAt expiredAt

export const ExchangeRate = () => {
  const { loadExchangeRates, error } = useExchangeRate();
  const { loadRecommendedRates } = useRecommendedRate();
  const { organization } = useUser();

  const tabItems: TabItem[] = [
    {
      key: 'buy',
      title: 'Покупка',
      content: (
        <ExchangeRateTable
          loader={loadExchangeRates}
          filterMode={EExchangeTableState.Buy}
        />
      ),
    },
    {
      key: 'sell',
      title: 'Продажа',
      content: (
        <ExchangeRateTable
          loader={loadExchangeRates}
          filterMode={EExchangeTableState.Sell}
        />
      ),
    },
  ];
  const proViderTabItems: TabItem[] = [
    {
      key: 'my exchange rates',
      title: 'Мои курсы',
      content: (
        <ExchangeRateTable
          loader={loadExchangeRates}
          tableMode={EExchangeTableMode.My}
        />
      ),
    },
    {
      key: 'main exchange rates',
      title: 'Общие курсы',
      content: <ExchangeRateTable loader={loadExchangeRates} />,
    },
    {
      key: 'recommended exchange rates',
      title: 'Рекомендуемые курсы',
      content: <RecommendedExchangeRates loader={loadRecommendedRates} />,
    },
  ];
  const adminTabItems: TabItem[] = [
    {
      key: 'buy',
      title: 'Покупка',
      content: (
        <AdminRateTable
          loader={loadExchangeRates}
          filterMode={EExchangeTableState.Buy}
        />
      ),
    },
    {
      key: 'sell',
      title: 'Продажа',
      content: (
        <AdminRateTable
          loader={loadExchangeRates}
          filterMode={EExchangeTableState.Sell}
        />
      ),
    },
    {
      key: 'recommended exchange rates',
      title: 'Рекомендуемые курсы',
      content: <RecommendedExchangeRates loader={loadRecommendedRates} />,
    },
  ];

  if (error) {
    return (
      <ErrorPage
        statusCode={'rates'}
        onAction={() => window.location.reload()}
      />
    );
  }

  return (
    <div className="h-full">
      {organization?.role?.id === RoleEnum.Provider ? (
        <Tabs
          items={proViderTabItems}
          defaultActiveKey="my exchange rates"
          theme={docsTabsTheme}
        />
      ) : organization?.role?.id === RoleEnum.Admin ? (
        <Tabs
          items={adminTabItems}
          defaultActiveKey="buy"
          theme={docsTabsTheme}
        />
      ) : (
        <Tabs items={tabItems} defaultActiveKey="buy" theme={docsTabsTheme} />
      )}
    </div>
  );
};
